import React, { Component } from "react";

class Servicios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [
        {
          key: 1,
          title: "Horario",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 2,
          title: "Oferta de clases",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 3,
          title: "Staff/ Profesores/ Gente/ Servicio",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 4,
          title: "Action Kids",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 5,
          title: "Gimnasio",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 6,
          title: "Cercanía",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 7,
          title: "Estacionamiento",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 8,
          title: "Alberca",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 9,
          title: "Mantenimiento",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 10,
          title: "Precio",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 11,
          title: "Baños",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 12,
          title: "Vestidores",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        },
        {
          key: 13,
          title: "Servicio",
          options: [
            {
              key: 1,
              active: false
            },
            {
              key: 2,
              active: false
            },
            {
              key: 3,
              active: false
            },
            {
              key: 4,
              active: false
            },
            {
              key: 5,
              active: false
            },
            {
              key: "NA",
              active: false
            }
          ]
        }
      ]
    };
  }

  click(index, item, value, indexValue) {
    for (var i in this.state.options) {
      for (var j in this.state.options[i].options) {
        this.state.options[index].options[j].active = false;
      }
    }
    this.state.options[index].options[indexValue].active = true;
    this.setState(this.state, () =>
      this.props.callbackValue(item.title, value.key, index)
    );
  }

  render() {
    const servicio = this.state.options.map((items, $index) => (
      <tr key={items.key}>
        <td>{items.title}</td>
        {items.options.map((cell, $indexCell) => (
          <td key={cell.key}>
            <i
              className={`survey-question-btn ${cell.active ? "active" : ""}`}
              onClick={() => this.click($index, items, cell, $indexCell)}
            >
              <i className="survey-question-btn-center" />
            </i>
          </td>
        ))}
      </tr>
    ));
    return (
      <div className="survey-question">
        <p className="survey-question-text">
          ¿Qué es lo que más te gusta de estar en Sportium? <span>*</span>
        </p>
        <p className="survey-question-subtext">
          1= ME GUSTA POCO / 5= ME GUSTA MUCHO / NA= NO APLICA, NO LO USO
        </p>
        <div className="survey-table-options">
          <table>
            <tbody>
              <tr className="survey-table-options-header">
                <td />
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
                <td>NA</td>
              </tr>
              {servicio}
            </tbody>
          </table>
        </div>
        <div className="survey-question-text">
          <div className="text-box-title">
            ¿Cómo podemos mejorar tu estancia?
          </div>
          <textarea cols="30" rows="10" onChange={this.props.callbackText} />
        </div>
      </div>
    );
  }
}

export default Servicios;



// WEBPACK FOOTER //
// ./src/components/Servicios.js